module.exports = __webpack_public_path__ + "img/744.54a6719e.jpg";